import { TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { ProgramAutomationRowForUi } from './program-automation.typing';

@RegisterYCState()
export class ProgramAutomationState extends BaseYcState {
  programAutomationRules: ProgramAutomationRowForUi[];
  activeProgramAutomationOptions: TypeaheadSelectOption[];
  allProgramAutomationOptions: TypeaheadSelectOption[];
  newRouteClicked: boolean;
  evaluationOrderClicked: boolean;
}
